import { IOWidget, Action, Pair, nothing, Unit } from "widgets-for-react";
import { ExtraImages } from "../../utils/extra_images.mod";
import { BlockData, CMSState } from "../../../cms/blocks/types.gen";
import { Block } from "../../../wordpress/types_and_parser/standard_blocks.gen";
import { MediaBlockProps, MediaBlockStyle, MediaBlock } from "./widgets/mediaBlock";
import { IframeBlockProps, IframeBlockStyle, IframeBlock } from "./widgets/iframeBlock";
import { CustomBlock } from "../../../wordpress/types_and_parser/custom_blocks.mod";
import { DownloadBlock, DownloadBlockProps } from "./widgets/downloadsBlock";
import { QuoteBlock, QuoteBlockProps, QuoteBlockStyle } from "./widgets/quoteBlock";
import { HeaderBlockProps, HeaderBlockStyle, HeaderBlock } from "./widgets/headerBlock.mod";
import { PublicSite_CustomPageData } from "../../application.mod";
import { CtaBlockStyle, CtaBlockProps, CtaBlock } from "./widgets/ctaBlock";
import { FormBlockProps, FormBlockStyle, FormBlock } from "./widgets/formBlock.mod";
import { NewsletterBlockProps, NewsletterBlockStyle, NewsletterBlock } from "./widgets/newsletterBlock.mod";
import { LatestBlockProps, LatestBlockStyle, LatestBlock } from "./widgets/latestBlock";
import { TableBlock, TableBlockProps, TableBlockStyle } from "./widgets/tableBlock.mod";
import { PublicSiteState } from "../../../public_site.main.mod";
import { ImageGalleryBlockProps, ImageGalleryBlockStyle, ImageGalleryBlock } from "./widgets/imageGalleryBlock";
import { ImageTextBlockProps, ImageTextBlockStyle, ImageTextBlock } from "./widgets/imageTextBlock.mod";
import { GridBlock, GridBlockStyle, GridBlockProps } from "./widgets/gridBlock.mod";
import { ImageStackBlockProps, ImageStackBlockStyle, ImageStackBlock } from "./widgets/imageStackBlock";
import { FactsAndFiguresBlock, FactsAndFiguresBlockProps, FactsAndFiguresBlockStyle } from "./widgets/factsAndFiguresBlock";
import { AttentionBlockProps, AttentionBlockStyle, AttentionBlock } from "./widgets/attentionBlock";
import { StepsBlock, StepsBlockProps, StepsBlockStyle } from "./widgets/stepsBlock";
import { TextBlockProps, TextBlock, TextBlockStyle } from "./widgets/textBlock";
import { FeaturedContentBlockProps, FeaturedContentBlock } from "./widgets/featuredContentBlock";
import { LinkBlockProps, LinkBlock } from "./widgets/linkBlock";
import { ExpandBlockProps, ExpandBlock } from "./widgets/expandableBlock";
import { BarometerBlockprops, BarometerBlock } from "./widgets/barometer";
import { GridHighlightsBlock, GridHighlightsBlockProps, GridHighlightsBlockStyle } from "./widgets/gridHighlightsBlock";
import { CarouselBlock, CarouselBlockProps, CarouselBlockStyle } from './widgets/carouselBlock'
import { VideoBlock, VideoBlockProps } from "./widgets/videoBlock";
import { GravityFormBlock, GravityFormBlockProps } from "./widgets/gravityFormBlock";
import { GameBlock, GameBlockProps } from "./widgets/gameblock";
import { BrochuresBlock, BrochuresBlockProps } from "./widgets/brochuresBlock";

//add here your custom blocks definitions
export type ctaBlockData = { kind: 'ctaBlock'; value: Pair<CtaBlockProps<ExtraImages>, CtaBlockStyle> }
export type downloadsBlockData = { kind: 'downloadsBlock'; value: Pair<DownloadBlockProps, any> }
export type formBlockData = { kind: 'formBlock'; value: Pair<FormBlockProps, FormBlockStyle> }
export type newsletterBlockData = { kind: 'newsletterBlock'; value: Pair<NewsletterBlockProps, NewsletterBlockStyle> }
export type headerBlockData = { kind: 'headerBlock'; value: Pair<HeaderBlockProps<ExtraImages>, HeaderBlockStyle> }
export type iframeBlockData = { kind: "iframeBlock"; value: Pair<IframeBlockProps, IframeBlockStyle> }
export type imageGalleryBlockData<extra_images> = { kind: "imageGalleryBlock"; value: Pair<ImageGalleryBlockProps<extra_images>, ImageGalleryBlockStyle> }
export type latestBlockData = { kind: 'latestBlock'; value: Pair<LatestBlockProps, LatestBlockStyle> }
export type mediaBlockData = { kind: "mediaBlock"; value: Pair<MediaBlockProps<ExtraImages>, MediaBlockStyle> }
export type videoBlockData = { kind: "videoBlock"; value: Pair<VideoBlockProps, MediaBlockStyle> }
export type quoteBlockData<extra_images> = { kind: "customQuoteBlock"; value: Pair<QuoteBlockProps<extra_images>, QuoteBlockStyle> }
export type tableBlockData = { kind: 'tableBlock'; value: Pair<TableBlockProps, TableBlockStyle> }
export type imageTextBlockData = { kind: 'imageTextBlock'; value: Pair<ImageTextBlockProps<ExtraImages>, ImageTextBlockStyle> }
export type gridBlockData = { kind: 'gridBlock'; value: Pair<GridBlockProps<ExtraImages>, GridBlockStyle> }
export type gridHighlightsBlockData = { kind: 'gridHighlightsBlock'; value: Pair<GridHighlightsBlockProps<ExtraImages>, GridHighlightsBlockStyle> }
export type carouselBlockData = { kind: 'carouselBlock'; value: Pair<CarouselBlockProps<ExtraImages>, CarouselBlockStyle> }
export type gridWithImageBlockData = { kind: 'gridWithImageBlock'; value: Pair<GridBlockProps<ExtraImages>, GridBlockStyle> }
export type imageStackBlockData = { kind: 'imageStackBlock'; value: Pair<ImageStackBlockProps<ExtraImages>, ImageStackBlockStyle> }
export type factsAndFiguresBlockData = { kind: 'factsAndFiguresBlock'; value: Pair<FactsAndFiguresBlockProps<ExtraImages>, FactsAndFiguresBlockStyle> }
export type attentionBlockData = { kind: 'attentionBlock'; value: Pair<AttentionBlockProps<ExtraImages>, AttentionBlockStyle> }
export type stepsBlockData = { kind: 'stepsBlock'; value: Pair<StepsBlockProps, StepsBlockStyle> }
export type textBlockData = { kind: 'textBlock'; value: Pair<TextBlockProps<CustomBlockData, ExtraImages>, TextBlockStyle> }
export type featuredContentBlockData = { kind: 'featuredContentBlock'; value: Pair<FeaturedContentBlockProps<CustomBlockData, ExtraImages>, any> }
export type linkListBlockData = { kind: 'linkListBlock'; value: Pair<LinkBlockProps, Unit> }
export type expandableBlockData = { kind: 'expandableBlock'; value: Pair<ExpandBlockProps<CustomBlockData, ExtraImages>, Unit> }
export type barometerBlockData = { kind: 'barometerBlock'; value: Pair<BarometerBlockprops<ExtraImages>, Unit> }
export type gravityFormBlockData = { kind: 'gravityFormBlock'; value: Pair<GravityFormBlockProps, Unit> }
export type gameblockData = { kind: "gameBlock"; value: Pair<GameBlockProps, Unit> }
export type brochuresBlockData = { kind: "brochuresBlock", value: Pair<BrochuresBlockProps, Unit> }

export type CustomBlockData =
    ctaBlockData
    | downloadsBlockData
    | formBlockData
    | newsletterBlockData
    | headerBlockData
    | iframeBlockData
    | imageGalleryBlockData<ExtraImages>
    | latestBlockData
    | mediaBlockData
    | videoBlockData
    | quoteBlockData<ExtraImages>
    | tableBlockData
    | imageTextBlockData
    | gridBlockData
    | gridHighlightsBlockData
    | carouselBlockData
    | gridWithImageBlockData
    | imageStackBlockData
    | factsAndFiguresBlockData
    | attentionBlockData
    | stepsBlockData
    | textBlockData
    | featuredContentBlockData
    | linkListBlockData
    | expandableBlockData
    | barometerBlockData
    | gravityFormBlockData
    | gameblockData
    | brochuresBlockData

export function isCustomBlockData<s, i>(b: BlockData<s, i> | CustomBlockData): b is CustomBlockData {
    return b.kind == "ctaBlock" ||
        b.kind == "downloadsBlock" ||
        b.kind == "formBlock" ||
        b.kind == "newsletterBlock" ||
        b.kind == "headerBlock" ||
        b.kind == "iframeBlock" ||
        b.kind == "imageGalleryBlock" ||
        b.kind == "latestBlock" ||
        b.kind == "mediaBlock" ||
        b.kind == "videoBlock" ||
        b.kind == "customQuoteBlock" ||
        b.kind == "tableBlock" ||
        b.kind == "imageTextBlock" ||
        b.kind == "gridBlock" ||
        b.kind == "gridHighlightsBlock" ||
        b.kind == "carouselBlock" ||
        b.kind == "imageStackBlock" ||
        b.kind == "factsAndFiguresBlock" ||
        b.kind == "attentionBlock" ||
        b.kind == 'stepsBlock' ||
        b.kind == 'textBlock' ||
        b.kind == 'featuredContentBlock' ||
        b.kind == 'linkListBlock' ||
        b.kind == 'expandableBlock' ||
        b.kind == 'gridWithImageBlock' ||
        b.kind == 'barometerBlock' ||
        b.kind == 'gravityFormBlock' ||
        b.kind == 'gameBlock' ||
        b.kind == 'brochuresBlock'
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
    return b.kind == "vidda/media" ||
        b.kind == "vidda/download" ||
        b.kind == "vidda/quote" ||
        b.kind == "vidda/iframe" ||
        b.kind == "vidda/header" ||
        b.kind == "vidda/form" ||
        b.kind == "vidda/newsletter" ||
        b.kind == "vidda/cta" ||
        b.kind == "vidda/latest" ||
        b.kind == "vidda/table" ||
        b.kind == "vidda/image-text" ||
        b.kind == "vidda/grid" ||
        b.kind == "vidda/grid-highlights" ||
        b.kind == "vidda/carousel" ||
        b.kind == "vidda/image-stack" ||
        b.kind == "vidda/facts-and-figures" ||
        b.kind == "vidda/attention" ||
        b.kind == "vidda/gallery" ||
        b.kind == 'vidda/steps' ||
        b.kind == 'vidda/text' ||
        b.kind == 'vidda/featured-content' ||
        b.kind == 'vidda/link-list' ||
        b.kind == 'vidda/expandable' ||
        b.kind == 'vidda/grid-with-image' ||
        b.kind == 'vidda/barometer' ||
        b.kind == 'vidda/video' ||
        b.kind == 'vidda/gravity-form' ||
        b.kind == 'vidda/game-block' || 
        b.kind == 'vidda/brochures'
}

export function renderCustomBlock(block: CustomBlockData, public_state: PublicSiteState, key?: string): IOWidget<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
    return s0 => {
        if (block.kind == "ctaBlock") {
            return CtaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "downloadsBlock") {
            return DownloadBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "formBlock") {
            return FormBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)(public_state)
        }
        else if (block.kind == "newsletterBlock") {
            return NewsletterBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)(public_state)
        }
        else if (block.kind == "headerBlock") {
            return HeaderBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "iframeBlock") {
            return IframeBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "imageGalleryBlock") {
            return ImageGalleryBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "latestBlock") {
            return LatestBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "mediaBlock") {
            return MediaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "videoBlock") {
            return VideoBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "customQuoteBlock") {
            return QuoteBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "carouselBlock") {
            return CarouselBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "tableBlock") {
            return TableBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "imageTextBlock") {
            return ImageTextBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "gridBlock") {
            return GridBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "gridHighlightsBlock") {
            return GridHighlightsBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "imageStackBlock") {
            return ImageStackBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "factsAndFiguresBlock") {
            return FactsAndFiguresBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "attentionBlock") {
            return AttentionBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "stepsBlock") {
            return StepsBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "textBlock") {
            return TextBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "featuredContentBlock") {
            return FeaturedContentBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)(public_state)
        }
        else if (block.kind == "linkListBlock") {
            return LinkBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "expandableBlock") {
            return ExpandBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "barometerBlock") {
            return BarometerBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "gravityFormBlock") {
            return GravityFormBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "gameBlock") {
            return GameBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "brochuresBlock") {
            return BrochuresBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)(public_state)
        }
        else {
            return nothing();
        }
    }
}

